import { BaseEntity } from "@app/models/rest/base-entity";
import { CommentType } from "@app/models/enums/comment-type.enum";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("comments")
export class CommentModel extends BaseEntity {
  public commentType: CommentType;
  public content: string;
}
